module.exports = fox._r("images/ad_scroll_forward.png", __webpack_public_path__ + "images/ad_scroll_forward.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/ad_scroll_forward.png
// module id = 975
// module chunks = 4